/**
 * "Home" for whoever is looking (ISSUE-1101 R5).
 *
 * With a session, home is app `/`, which forwards to Scores. Without one, app
 * `/` runs `requireSignedIn` and sends the visitor straight back to the
 * sign-in screen they are already on, so home is the marketing site instead.
 *
 * Used by the shell wordmark and by the 404 and route error screens' "Go to
 * home". Every prop lands on the rendered anchor, so `Button asChild` can
 * style it the same either way.
 */
import { Link } from "@tanstack/react-router";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

import { useAuth } from "../auth/AuthProvider";
import { SPORTSMET_SITE_URL } from "../features/account/helpAndAboutCopy";

// `target` is left out: home always opens in the same tab, and the router
// types it as a required string under exactOptionalPropertyTypes.
type typeHomeLinkProps = Omit<ComponentPropsWithoutRef<"a">, "href" | "target">;

export const HomeLink = ({
  children,
  ...anchorProps
}: typeHomeLinkProps): ReactNode => {
  const { state } = useAuth();
  if (state.status === "signedIn") {
    return (
      <Link to="/" {...anchorProps}>
        {children}
      </Link>
    );
  }
  return (
    <a href={SPORTSMET_SITE_URL} {...anchorProps}>
      {children}
    </a>
  );
};
